import styled from "@emotion/styled";

import { inputWidthCss } from "src/pages/Fundraiser/EditForm/styles";
import { verticalStackCss } from "src/theme/spacing";
import { FontWeight, textSizeCss } from "src/theme/text";

export const Fieldset = styled.fieldset`
  legend {
    ${textSizeCss.m};
    font-weight: ${FontWeight.BOLD};
  }
  ${verticalStackCss.m};
  ${inputWidthCss};
`;
export const RadioGroup = styled.div`
  ${verticalStackCss.xs};
  align-items: flex-start;
`;
